import { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'

import MobileHeader from '../Common/Header/MobileHeader'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import {
  APPROVAL_STATUS,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
  PHARMACY_REQUEST_TYPE,
} from '../../common/constant/page-constant'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import SearchIcon from '../../assets/SearchIcon'
import CloseIcon from '../../assets/CloseIcon'
import {
  getAllPharmacyRequestHelper,
  updatePharmacyRequestHelper,
} from '../../helper/settings-helper'
import './PharmacyRequest.scss'
import {
  addProductAlertAction,
  updateSupplierAlertAction,
} from '../../modules/actions/action'
import DotsIcon from '../../assets/DotsIcon'
import moment from 'moment'

const PharmacyRequest = (props) => {
  const isMobile = useCheckMobileScreen()
  const inputRef = useRef()

  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.MANAGE_CUSTOMER,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick(),
  })
  const [activeType, setActiveType] = useState(PHARMACY_REQUEST_TYPE.PRODUCT)
  const [managePharmacyRequestData, setManagePharmacyRequestData] = useState([])
  const [requestData, setRequestData] = useState([])
  const [filteredRequestData, setFilteredRequestData] = useState([])
  const [viewSearch, setViewSearch] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [permissions, setPermissions] = useState({})
  // const [updateProductAlert, setUpdateProductAlert] = useState(false)
  const [activeCardId, setActiveCardId] = useState(false)
  const [serverError, setServerError] = useState(undefined)

  useEffect(() => {
    getPharmacyRequestData()
  }, [])

  useEffect(() => {
    if (activeType === PHARMACY_REQUEST_TYPE.PRODUCT) {
      setRequestData(managePharmacyRequestData?.products)
      setFilteredRequestData(managePharmacyRequestData?.products)
      setFilteredRequestData(managePharmacyRequestData?.products)
      return
    }

    setRequestData(managePharmacyRequestData?.suppliers)
    setFilteredRequestData(managePharmacyRequestData?.suppliers)
    setFilteredRequestData(managePharmacyRequestData?.suppliers)
  }, [activeType, managePharmacyRequestData])

  console.log('LOGINDATA: ', props)

  useEffect(() => {
    if (props.loginData.permissions) {
      console.log('props.loginData.permissions: ', props.loginData.permissions)

      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.SETTINGS
      )[0]

      console.log('home screen permission: ', permission)
      if (permission) setPermissions(permission)

      if (
        permission?.features?.[PERMISSION_FEATURE.NEW_PRODUCT_REQUEST] ===
        PERMISSION_TYPE.RESTRICTED
      ) {
        setActiveType(PHARMACY_REQUEST_TYPE.SUPPLIER)
      }
    }
  }, [props.loginData])

  useEffect(() => {
    let rData = requestData?.filter(
      (product) =>
        product?.supplier_name
          ?.toUpperCase()
          ?.includes(searchTerm?.toUpperCase()) ||
        product?.product_details
          ?.toUpperCase()
          ?.includes(searchTerm?.toUpperCase()) ||
        product?.name?.toUpperCase()?.includes(searchTerm?.toUpperCase())
    )

    setFilteredRequestData(rData)
  }, [searchTerm])

  const getPharmacyRequestData = async () => {
    try {
      let data = await getAllPharmacyRequestHelper()
      setManagePharmacyRequestData(data)
    } catch (err) {
      console.log('err: ', err)
    }
  }

  const expandSearch = () => {
    inputRef.current.focus(setViewSearch(true))
  }

  const handleCardAction = async (id, action) => {
    console.log('action clicked !!', action)

    try {
      let status = action === APPROVAL_STATUS.APPROVE

      let data = {
        status: status,
        id: id,
      }
      await updatePharmacyRequestHelper(data, activeType)
      getPharmacyRequestData()
    } catch (err) {
      console.log('err: ', err)
    }
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      <div className="pageBodyRightPanel">
        {isMobile && (
          <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
            <div
              className={'formGroup mb-0 searchBar expand'}
              onClick={expandSearch}
              onBlur={() => setViewSearch(false)}
            >
              <input
                ref={inputRef}
                type="text"
                className="formControl"
                placeholder="Search Product or Supplier Name"
                onChange={(e) => setSearchTerm(e?.target?.value)}
              />
              <div className={`searchIcon`}>
                <SearchIcon />
              </div>
            </div>
          </div>
        )}
        {!isMobile && (
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
            <div className="pageBodyRightPanelHeading">
              Manage Pharmacy Requests
            </div>
            <div className="addProductBtn dFlex aiCenter">
              <div
                className={`formGroup mb-0 searchBar expand`}
                onClick={expandSearch}
                onBlur={() => setViewSearch(false)}
              >
                <input
                  ref={inputRef}
                  type="text"
                  className="formControl"
                  placeholder="Search Product or Supplier Name"
                  onChange={(e) => setSearchTerm(e?.target?.value)}
                />
                <div className={`searchIcon`}>
                  <SearchIcon />
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="salesWrapper mt-5">
          <ul className="tabs dFlex">
            {permissions?.features?.[PERMISSION_FEATURE.NEW_PRODUCT_REQUEST] !==
              PERMISSION_TYPE.RESTRICTED && (
              <li
                className={`tabItem ${
                  activeType === PHARMACY_REQUEST_TYPE.PRODUCT ? 'active' : ''
                }`}
                onClick={() => setActiveType(PHARMACY_REQUEST_TYPE.PRODUCT)}
              >
                Product
              </li>
            )}
            {permissions?.features?.[
              PERMISSION_FEATURE.NEW_SUPPLIER_REQUEST
            ] !== PERMISSION_TYPE.RESTRICTED && (
              <li
                className={`tabItem ${
                  activeType === PHARMACY_REQUEST_TYPE.SUPPLIER ? 'active' : ''
                }`}
                onClick={() => setActiveType(PHARMACY_REQUEST_TYPE.SUPPLIER)}
              >
                Supplier/Manufacturer
              </li>
            )}
          </ul>
        </div>
        <div className="productLlistWrap">
          {filteredRequestData &&
            activeType === PHARMACY_REQUEST_TYPE.PRODUCT && (
              <div className="tabContent mb-4">
                <div className="">
                  <table className="table productTable">
                    <thead>
                      <tr>
                        {/* <th width="1%"></th>
                        <th width="15%">Date & Time</th>

                        <th width="35%">Product Details (Name-Size-Generic)</th>
                        <th width="10%">Category</th>
                        <th width="16%">Supplier/Manufacturer</th>
                        <th width="7%">Origin</th>
                        <th width="9%">RPU (BDT)</th>
                        <th width="12%">Prescription Mode</th>
                        <th width="16%">Requested By (Pharmacy & User)</th> */}
                        <th width="2%"></th>
                        <th width="12%">Date & Time</th>
                        <th width="20%">Product Details (Name-Size-Generic)</th>
                        <th width="10%">Category</th>
                        <th width="13%">Supplier/Manufacturer</th>
                        <th width="8%">Origin</th>
                        <th width="5%">RPU (BDT)</th>
                        <th width="10%">Prescription Mode</th>
                        <th width="20%">Requested By (Pharmacy & User)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRequestData?.map((item, index) => (
                        <tr key={2}>
                          <td>
                            {permissions?.features?.[
                              PERMISSION_FEATURE.NEW_PRODUCT_REQUEST
                            ] === PERMISSION_TYPE.MANAGE && (
                              <div className="cardHeaderRight">
                                {activeCardId === item?.id ? (
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setActiveCardId(undefined)
                                    }}
                                  >
                                    <CloseIcon />
                                  </span>
                                ) : (
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setActiveCardId(item?.id)
                                    }}
                                  >
                                    <DotsIcon />
                                  </span>
                                )}
                                {activeCardId === item?.id && (
                                  <ul
                                    className={`cardActionsWrapper ${
                                      activeCardId === item?.id
                                        ? 'show'
                                        : 'hide'
                                    }`}
                                  >
                                    <li
                                      className="actionItem"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleCardAction(
                                          item?.id,
                                          APPROVAL_STATUS.APPROVE
                                        )
                                      }}
                                    >
                                      {APPROVAL_STATUS.APPROVE}
                                    </li>
                                    <li
                                      className="actionItem"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleCardAction(
                                          item?.id,
                                          APPROVAL_STATUS.REJECT
                                        )
                                      }}
                                    >
                                      {APPROVAL_STATUS.REJECT}
                                    </li>
                                  </ul>
                                )}
                              </div>
                            )}
                          </td>
                          <td
                            className="dateTimeCell"
                            title={moment(item.created_at).format(
                              'MMMM Do YYYY, h:mm a'
                            )}
                          >
                            <div className="dualDataCentered">
                              <span>
                                {moment(item.created_at).format('MMMM Do YYYY')}
                                ,
                              </span>
                              <span>
                                {moment(item.created_at).format('h:mm a')}
                              </span>
                            </div>
                          </td>

                          <td title={item.product_details}>
                            {item.product_details}
                          </td>
                          <td title={item.category}>{item.category}</td>
                          <td title={item.supplier_name}>
                            {item.supplier_name}
                          </td>
                          <td title={item.origin}>{item.origin}</td>
                          <td title={item.rate_per_unit}>
                            {item.rate_per_unit}
                          </td>
                          <td>
                            {item.is_prescription_required
                              ? 'Required'
                              : 'Not Required'}
                          </td>
                          <td>
                            <div className="dualData">
                              <span title={item.requested_by}>
                                <span className="highlightedData">
                                  Pharmacy:
                                </span>{' '}
                                {item.requested_by}
                              </span>
                              <span title={item?.requested_user_name}>
                                <span className="highlightedData">User:</span>{' '}
                                {item?.requested_user_name}
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          {filteredRequestData &&
            activeType === PHARMACY_REQUEST_TYPE.SUPPLIER && (
              <div className="tabContent mb-4">
                <div className="">
                  <table className="table productTable">
                    <thead>
                      <tr>
                        <th width="1%"></th>

                        <th width="15%">Date & Time</th>
                        <th width="30%">Supplier/Manufacturer</th>
                        <th width="17%">Phone Number</th>
                        <th width="30%">Address</th>
                        <th width="23%">Requested By (Pharmacy & User)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRequestData?.map((item, index) => (
                        <tr key={2}>
                          <td>
                            {permissions?.features?.[
                              PERMISSION_FEATURE.NEW_SUPPLIER_REQUEST
                            ] === PERMISSION_TYPE.MANAGE && (
                              <div className="cardHeaderRight">
                                {activeCardId === item?.id ? (
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setActiveCardId(undefined)
                                    }}
                                  >
                                    <CloseIcon />
                                  </span>
                                ) : (
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setActiveCardId(item?.id)
                                    }}
                                  >
                                    <DotsIcon />
                                  </span>
                                )}
                                {activeCardId === item?.id && (
                                  <ul
                                    className={`cardActionsWrapper ${
                                      activeCardId === item?.id
                                        ? 'show'
                                        : 'hide'
                                    }`}
                                  >
                                    <li
                                      className="actionItem"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleCardAction(
                                          item?.id,
                                          APPROVAL_STATUS.APPROVE
                                        )
                                      }}
                                    >
                                      {APPROVAL_STATUS.APPROVE}
                                    </li>
                                    <li
                                      className="actionItem"
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleCardAction(
                                          item?.id,
                                          APPROVAL_STATUS.REJECT
                                        )
                                      }}
                                    >
                                      {APPROVAL_STATUS.REJECT}
                                    </li>
                                  </ul>
                                )}
                              </div>
                            )}
                          </td>

                          <td
                            className="dateTimeCell"
                            title={moment(item.created_at).format(
                              'MMMM Do YYYY, h:mm a'
                            )}
                          >
                            <div className="dualDataCentered">
                              <span>
                                {moment(item.created_at).format('MMMM Do YYYY')}
                                ,
                              </span>
                              <span>
                                {moment(item.created_at).format('h:mm a')}
                              </span>
                            </div>
                          </td>
                          <td title={item.name}>{item.name}</td>
                          <td>{item.mobile_no}</td>
                          <td title={item.address}>{item.address}</td>
                          <td>
                            <div className="dualData">
                              <span title={item.requested_by}>
                                <span className="highlightedData">
                                  Pharmacy:
                                </span>{' '}
                                {item.requested_by}
                              </span>
                              <span title={item?.requested_user_name}>
                                <span className="highlightedData">User:</span>{' '}
                                {item?.requested_user_name}
                              </span>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    alert: state.alertReducer.alert,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addProductAlertAction: (payload) =>
      dispatch(addProductAlertAction(payload)),
    updateSupplierAlertAction: (payload) =>
      dispatch(updateSupplierAlertAction(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PharmacyRequest)
